// extracted by mini-css-extract-plugin
export default {"imageWrapper":"TK-z","twoColumnImage":"UK-z"};